import PatientListComposer from '../../../composers/PatientListComposer';

export default function PatientListPage(): JSX.Element {
  return <PatientListComposer />;
}
